import React, { useMemo, memo, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTable, useRowSelect } from "react-table";
import numeral from "numeral";
import classNames from "classnames";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";
import { useState } from "react";

const IndeterminateCheckbox = React.forwardRef(
  ({ onChange, id, selectedFlatRows, flatRows, ...rest }, ref) => {
    useEffect(() => {
      const getIdAll = document.getElementById("ALL");
      if (selectedFlatRows?.length > 0) {
        const newRows = flatRows
          .map((row) => {
            // if (row.original.tracking_id) {
            return row;
            // }
          })
          .filter((row) => row);
        getIdAll.checked = newRows.length === selectedFlatRows.length;
        getIdAll.indeterminate = newRows.length !== selectedFlatRows.length;
        return;
      }
      getIdAll.indeterminate = false;
      getIdAll.checked = false;
    }, [selectedFlatRows]);

    return (
      <>
        <input
          type="checkbox"
          id={id}
          onChange={onChange}
          {...rest}
          style={{ width: "20px", height: "20px" }}
        />
      </>
    );
  }
);

const Row = memo(({ row, i, value, getData }) => {
  const [showModal, setShowModal] = useState(false);

  const alignByIndex = (index) => {
    // if (index == 0) return "text-left";
    // if (index == 1) return "text-right";
    return "text-center";
  };

  return (
    <React.Fragment>
      <tr
        onClick={() => setShowModal(true)}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 " + alignByIndex(index)}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      {showModal && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm    "
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className=" bg-white rounded-lg border text-gray-500         w-2/5  h-auto  flex flex-col justify-center items-center mx-auto my-36 py-10">
            {" "}
            <div className="font-bold text-gray-700 text-xl mb-4">
              {" "}
              รายละเอียด
            </div>
            <div className="grid grid-cols-1 gap-2">
              <div className=" font-light">
                <span className=" text-gray-500 font-bold mr-2">
                  ชื่อผู้รับ :{" "}
                </span>{" "}
                {value.reciever}
              </div>

              <div>
                <span className=" text-gray-500 font-bold mr-2">
                  Order id :{" "}
                </span>{" "}
                {value.order_id}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">
                  จัดส่งที่ :{" "}
                </span>{" "}
                {value.address}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">
                  เลขติดตามการขนส่ง :{" "}
                </span>{" "}
                {value.tracking_id}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">
                  เบอร์โทร :{" "}
                </span>{" "}
                {value.phone_number}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">สินค้า : </span>{" "}
                {value.item_name}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">point : </span>{" "}
                {value.points}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">Unit : </span>{" "}
                {value.unit}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">
                  วันที่สร้าง :{" "}
                </span>{" "}
                {new Date(value.timestamp).toLocaleString("th-TH")}
              </div>
              <div>
                <span className=" text-gray-500 font-bold mr-2">สถานะ : </span>{" "}
                <span
                  className={
                    value.order_status == "PENDING"
                      ? "text-yellow-500"
                      : "text-green-500"
                  }
                >
                  {row.values.order_status}
                </span>
              </div>
            </div>
            <button
              className=" mt-8 text-white p-2 px-8 bg-red-500 rounded"
              onClick={() => setShowModal(!showModal)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
});

function GiftRequestTable({ data, getData, where, setSelectedRows }) {
  const { user } = useSelector((state) => state.initializeApp);

  const onStatus =
    ({
      order_id,
      phone_number,
      order_status,
      points,
      tracking_id,
      deviceToken,
    }) =>
    async (e) => {
      e.stopPropagation();
      try {
        let result;
        if (order_status === "APPROVE") {
          result = await Swal.fire({
            titleText: `${order_id}`,
            title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่",
            text: "หมายเลขการขนส่ง",
            inputAttributes: {
              autocapitalize: "off",
            },
            input: "text",
            showCancelButton: true,
            confirmButtonText: `บันทึก`,
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            showLoaderOnDeny: false,
            preConfirm: async (tracking_id) => {
              if (!tracking_id) {
                await Swal.fire({
                  title: "ERROR",
                  text: "โปรดกรอกหมายเลขติดตามการขนส่ง",
                  icon: "error",
                  confirmButtonText: "ยืนยัน",
                });
              } else {
                await API.put("MoneyHubAdmin", `/giftRequest/${order_id}`, {
                  body: {
                    order_status,
                    phone_number,
                    points,
                    tracking_id,
                    deviceToken,
                    adminName: user.username,
                  },
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                });
              }
            },
          });
        } else {
          result = await Swal.fire({
            title: "คุณยืนยันที่จะปฎิเสธคำขอนี้หรือไม่ ?",
            showCancelButton: true,
            confirmButtonText: `บันทึก`,
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            showLoaderOnDeny: false,
            preConfirm: async () => {
              await API.put("MoneyHubAdmin", `/giftRequest/${order_id}`, {
                body: {
                  order_status,
                  phone_number,
                  points,
                  tracking_id,
                  deviceToken,
                  adminName: user.username,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              });
            },
          });
        }
        if (!result.isConfirmed) return;
        await Swal.fire({
          title: "SUCCESS",
          text: "สร้างสินค้าสำเร็จ",
          icon: "success",
          confirmButtonText: "ยืนยัน",
        });
        await getData(where);
      } catch (error) {
        console.log("Error", error);
        await Swal.fire({
          title: "ERROR",
          text: "Something went wrong",
          icon: "error",
          confirmButtonText: "ยืนยัน",
        });
      }
    };

  const columns = useMemo(
    () => [
      {
        Header: "Order No.",
        accessor: "order_id", // accessor is the "key" in the data
      },
      {
        Header: "เลขติดตามการขนส่ง",
        accessor: "tracking_id",
      },
      {
        Header: "ชื่อผู้รับ",
        accessor: "reciever",
      },
      {
        Header: "เบอร์โทร",
        accessor: "phone_number",
      },
      {
        Header: "สินค้า",
        accessor: "item_name",
      },
      {
        Header: "Points",
        accessor: "points",
      },
      {
        Header: "Unit",
        accessor: "unit",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "timestamp",
        Cell: ({ row }) => {
          return (
            <div>{format(new Date(row.values.timestamp), "dd/MM/yyyy")}</div>
          );
        },
      },
      {
        Header: "สถานะ",
        accessor: "order_status",
        Cell: ({ row }) => {
          const { order_status } = row.values;
          return (
            <div
              className={classNames({
                "text-red-500": order_status === "REJECT",
                "text-green-500": order_status === "APPROVE",
                "text-yellow-500": order_status === "PENDING",
              })}
            >
              {order_status}
            </div>
          );
        },
      },
      {
        Header: "อัพเดตสถานะ",
        accessor: "username",
        Cell: ({ row }) => {
          const { order_id, phone_number, points, order_status, deviceToken } =
            row.original;
          return (
            <div className="flex items-center justify-center">
              <button
                disabled={order_status !== "PENDING"}
                onClick={onStatus({
                  order_id,
                  phone_number,
                  order_status: "APPROVE",
                  points,
                  deviceToken,
                  tracking_id: "",
                })}
                className={classNames(
                  "mx-2 px-2 py-1 text-sm rounded text-white shadow-sm duration-300 transition-all focus:outline-none",
                  {
                    "bg-green-500 hover:bg-green-600":
                      order_status === "PENDING",
                    "bg-gray-400 cursor-not-allowed":
                      order_status !== "PENDING",
                  }
                )}
              >
                APPROVE
              </button>
              <button
                disabled={order_status !== "PENDING"}
                onClick={onStatus({
                  order_id,
                  phone_number,
                  order_status: "REJECT",
                  points,
                  deviceToken,
                  tracking_id: "",
                })}
                className={classNames(
                  "mx-2 px-2 py-1 text-sm rounded text-white shadow-sm duration-300 transition-all focus:outline-none",
                  {
                    "bg-red-500 hover:bg-red-600": order_status === "PENDING",
                    "bg-gray-400 cursor-not-allowed":
                      order_status !== "PENDING",
                  }
                )}
              >
                REJECT
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable({ columns, data }, useRowSelect, (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "selection",
        Header: ({
          flatRows,
          getToggleAllRowsSelectedProps,
          toggleRowSelected,
          rows,
          ...props
        }) => {
          const onChangeAll = (e) => {
            flatRows.forEach((row) => {
              const { tracking_id } = row.original;
              // if (tracking_id) {
              toggleRowSelected(row.id, e.target.checked);
              // }
            });
          };

          return (
            <div>
              <IndeterminateCheckbox
                onChange={onChangeAll}
                flatRows={flatRows}
                id="ALL"
                // disabled={rows.every((row) => row.original?.disabled_import)}
                // {...getToggleAllRowsSelectedProps()}
              />
            </div>
          );
        },
        Cell: ({
          row,
          toggleRowSelected,
          selectedFlatRows,
          flatRows,
          ...props
        }) => {
          const loan_status = row.values.loan_status;

          return (
            <div className="pointer-events-auto cursor-pointer">
              <IndeterminateCheckbox
                selectedFlatRows={selectedFlatRows}
                flatRows={flatRows}
                onClick={(e) => e.stopPropagation()}
                {...row.getToggleRowSelectedProps()}
                // disabled={row.original?.disabled_import}
              />
            </div>
          );
        },
      },
      ...columns,
    ]);
  });

  useEffect(() => {
    setSelectedRows(selectedFlatRows);
  }, [selectedFlatRows]);

  return (
    <div className="mx-4 mb-2">
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  where={where}
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default GiftRequestTable;
